__turbopack_context__.v({
  "descriptionText": "GrYnUa_descriptionText",
  "desktopImage": "GrYnUa_desktopImage",
  "featuredImageContainer": "GrYnUa_featuredImageContainer",
  "mobileImage": "GrYnUa_mobileImage",
});
